
import barba from '@barba/core';

export default class{

    constructor(){
        barba.hooks.once((data) => {
            this.init()
        })
        barba.hooks.after((data) => {
            this.init()
        });
    }
    init (){
        new Vue({
			el: '#area-search',
			data: {
				selected_area: "",
				selected_pref : "",
				selected_prefs: [],
				areas : [
					"北海道・東北",
                    "甲信越・北陸",
					"関東",
					"東海",
					"近畿",
					"中国・四国",
					"九州"
				],
				prefs : [
					[
						{
							"name":"北海道",
							"url":"hokkaido"
						},
						{
							"name":"青森県",
							"url":"aomori"
						},
						{
							"name":"岩手県",
							"url":"iwate"
						},
						{
							"name":"宮城県",
							"url":"miyagi"
						},
						{
							"name":"秋田県",
							"url":"akita"
						},
						{
							"name":"山形県",
							"url":"yamagata"
						},
						{
							"name":"福島県",
							"url":"fukushima"
						},
					],
                    [
						{
							"name":"山梨県",
							"url":"yamanashi"
						},
                        {
							"name":"長野県",
							"url":"nagano"
						},
                        {
							"name":"新潟県",
							"url":"niigata"
						},
						{
							"name":"富山県",
							"url":"toyama"
						},
						{
							"name":"石川県",
							"url":"ishikawa"
						},
						{
							"name":"福井県",
							"url":"fukui"
						},
					],
					[
						{
							"name":"東京都",
							"url":"tokyo"
						},
                        {
							"name":"神奈川",
							"url":"kanagawa"
						},
                        {
							"name":"千葉県",
							"url":"chiba"
						},
                        {
							"name":"埼玉県",
							"url":"saitama"
						},
                        {
							"name":"茨城県",
							"url":"ibaraki",
						},
						{
							"name":"栃木県",
							"url":"tochigi"
						},
						{
							"name":"群馬県",
							"url":"gunma"
						},
					],
					[
						{
							"name":"愛知県",
							"url":"aichi"
						},
                        {
							"name":"岐阜県",
							"url":"gifu"
						},
						{
							"name":"静岡県",
							"url":"shizuoka"
						},
						{
							"name":"三重県",
							"url":"mie"
						},
					],
					[
						{
							"name":"大阪府",
							"url":"osaka"
						},
                        {
							"name":"兵庫県",
							"url":"hyogo"
						},
                        {
							"name":"京都府",
							"url":"kyoto"
						},
                        {
							"name":"滋賀県",
							"url":"shiga"
						},
						{
							"name":"奈良県",
							"url":"nara"
						},
						{
							"name":"和歌山県",
							"url":"wakayama"
						},
					],
					[
						{
							"name":"岡山県",
							"url":"okayama"
						},
                        {
							"name":"鳥取県",
							"url":"tottori"
						},
                        {
							"name":"広島県",
							"url":"hiroshima"
						},
						{
							"name":"島根県",
							"url":"shimane"
						},
						{
							"name":"山口県",
							"url":"yamaguchi"
						},
						{
							"name":"徳島県",
							"url":"tokushima"
						},
                        {
							"name":"高知県",
							"url":"kochi"
						},
						{
							"name":"香川県",
							"url":"kagawa"
						},
						{
							"name":"愛媛県",
							"url":"ehime"
						},
					],
					[
						{
							"name":"福岡県",
							"url":"fukuoka"
						},
                        {
							"name":"長崎県",
							"url":"nagasaki"
						},
                        {
							"name":"宮崎県",
							"url":"miyazaki"
						},
                        {
							"name":"熊本県",
							"url":"kumamoto"
						},
						{
							"name":"佐賀県",
							"url":"saga"
						},
						{
							"name":"大分県",
							"url":"oita"
						},
						{
							"name":"鹿児島県",
							"url":"kagoshima"
						},
						{
							"name":"沖縄県",
							"url":"okinawa"
						},
					]
				]
			},
			methods : {
				_set_area : function(){
					if(this.selected_area !== ""){
						this.selected_pref = "";
						this.selected_prefs = this.prefs[this.selected_area];
					}else{
						this.selected_prefs = [];
					}
				},
				_goto_url :function(){
					if(this.selected_pref !=""){
						window.location.href = this.selected_pref;
					}
				}
			}
		});
    }
}